import clsx from 'clsx';
import { Collapse } from 'react-collapse';
import { useMemo, useState } from 'react';

import iconArrow from '../../assets/images/icon-arrow-down.svg';
import { Input } from '../input';
import { CheckBox } from '../check-box2';

import styles from './styles.module.scss';

type IFilterSelectValue = (string | null) | (string | number)[];

interface IFilterSelectOption {
  key: string | number;
  label: string | number;
}
interface FilterSelectProps {
  label: string;
  value?: IFilterSelectValue;
  options: IFilterSelectOption[];
  onSelect(value: IFilterSelectValue): void;
  onFocus?: () => void;
  onBlur?: () => void;
}

const FilterSelect = (props: FilterSelectProps) => {
  const { label, value, options, onSelect, onFocus, onBlur } = props;

  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(true);
  const [showAll, setShowAll] = useState(false);

  const { filtered, filteredSliced, optionsDiff } = useMemo(() => {
    let filtered = [...options];
    if (search) {
      filtered = options.filter((o) => (o.label + '').toLowerCase().includes(search.toLowerCase()));
    }
    const filteredSliced = filtered.slice(0, 6);
    return {
      filtered,
      filteredSliced,
      optionsDiff: filtered.length - filteredSliced.length,
    };
  }, [search, options]);

  const handleSelect = (key: number | string) => () => {
    if (Array.isArray(value)) {
      value
        ? onSelect(value.includes(key) ? value.filter((v) => v !== key) : [...value, key])
        : onSelect([key]);
    } else {
      const val = key as string;
      onSelect(value === val ? null : val);
    }
  };

  return (
    <div
      className={clsx(
        styles.container,
        isOpen && styles.containerOpened,
        !!value?.length && styles.containerActive,
      )}
    >
      <div onClick={() => setIsOpen(!isOpen)} className={styles.header}>
        <span className={styles.title}>{label}</span>

        <img src={iconArrow} className={styles.arrow} />
      </div>

      <Collapse isOpened={isOpen}>
        <div className={styles.inner}>
          <Input
            size='md'
            value={search}
            onChange={setSearch}
            className={styles.search}
            placeholder='Найти'
            onFocus={onFocus}
            onBlur={onBlur}
          />

          {(showAll ? filtered : filteredSliced).map((option) => (
            <div key={option.key} onClick={handleSelect(option.key)} className={styles.option}>
              <CheckBox
                checked={Array.isArray(value) ? value?.includes(option.key) : value === option.key}
                readOnly
                onChange={() => handleSelect(option.key)}
                isOptionKey={true}
              />
              {option.label}
            </div>
          ))}

          {!filtered.length && <div className={styles.empty}>Список пуст</div>}

          <div className={styles.actions}>
            {optionsDiff > 0 ? (
              <button
                type='button'
                onClick={() => setShowAll(!showAll)}
                className={clsx(styles.action, styles.more)}
              >
                {showAll ? 'Скрыть' : `Показать еще ${optionsDiff}`}
              </button>
            ) : (
              <span />
            )}

            <button
              type='button'
              onClick={() => onSelect([])}
              className={clsx(styles.action, styles.reset)}
            >
              {value?.length ? 'Сбросить' : ''}
            </button>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default FilterSelect;
